import { render, staticRenderFns } from "./ListGroupItem.vue?vue&type=template&id=abf735f0&scoped=true&"
import script from "./ListGroupItem.vue?vue&type=script&lang=ts&"
export * from "./ListGroupItem.vue?vue&type=script&lang=ts&"
import style0 from "./ListGroupItem.vue?vue&type=style&index=0&id=abf735f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abf735f0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VListGroup } from 'vuetify/lib/components/VList';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VListGroup,VSpacer})
